import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Constants from '~/app/Constants';

export interface NotFoundRedirectPageProps { }

const NotFoundRedirectPage: FC<NotFoundRedirectPageProps> = () => {
  const location = useLocation();
  const pageExists = Object.values(Constants.Pages).includes(location.pathname);
  return (pageExists ? null : <Navigate to={Constants.Pages.notFound} />);
};

export default NotFoundRedirectPage;
